import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { Helmet } from 'react-helmet'
import { injectIntl } from 'react-intl'
import DailyReportAction from 'redux/dailyreports/actions'
import { Typography } from 'antd'
import { createStructuredSelector } from 'reselect'
import { selectDailyReport, selectedDailyReportData } from 'redux/dailyreports/selectors'
import ViewReports from './ViewReports'

const { Text } = Typography

const mapStateToProps = () =>
  createStructuredSelector({
    dailyreports: selectDailyReport,
    selectedDailyReport: selectedDailyReportData,
  })

const DailyReports = ({ selectedDailyReport, intl: { formatMessage } }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch({
      type: DailyReportAction.LOAD_ALL,
    })
  }, [dispatch])

  const path = window.location.pathname
  const userId = path.replace('/manage/accounts/', '')

  const dailyReportData = selectedDailyReport?.filter(data => data.id === userId)

  const dailyReportCount = dailyReportData?.length || 0

  return (
    <div>
      <Helmet title={formatMessage({ id: 'title.helmet.dailyReports' })} />
      <div className="card">
        <div className="card-body">
          <h5 className="mb-4">
            <strong>{formatMessage({ id: 'text.DailyReportList' })}</strong>
            &nbsp;&nbsp;
            <Text className="font-size-16 font-weight-bold" code>
              {formatMessage({ id: 'text.totalCount' }, { count: dailyReportCount })}
            </Text>
          </h5>
          <ViewReports />
        </div>
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(injectIntl(DailyReports))
